import React from 'react';

const PricingRules: React.FunctionComponent<React.PropsWithChildren> = () => {
    return <div>PricingRules</div>;
};

export default PricingRules;
